import { render, staticRenderFns } from "./true.vue?vue&type=template&id=6c2b2ee7&scoped=true"
import script from "./true.vue?vue&type=script&lang=js"
export * from "./true.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b2ee7",
  null
  
)

export default component.exports